import type { ReactNode } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

type ComingSoonProps = {
  title: ReactNode;
  description?: ReactNode;
};

export const ComingSoon = ({ title, description }: ComingSoonProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={SPACING.X_SMALL}
    className={styles.emptyTabState}
  >
    <Text variant="h4" align="center" className={styles.mutedHeading}>
      {title}
    </Text>
    {description && (
      <Text variant="secondary-md" align="center">
        {description}
      </Text>
    )}
  </Flex>
);
